import React, { useContext, useState } from "react";
import { StoreContext } from "../../../../storeroom/StoreContext";
import { useObserver } from "mobx-react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from "@material-ui/core";
import { deepCopy } from "../../../../utils";

interface Props {
  show: boolean;
  onClose: () => void;
}

export default function ListingTitleForm(props: Props) {
  const store = useContext(StoreContext);
  const listing = store.listingStore.listing;

  const [pending, setPending] = useState(false);
  const [title, setTitle] = useState(listing.title);

  const onChange = (event: any) => {
    setTitle(event.target.value);
  };

  const onSubmit = (event: any) => {
    event.preventDefault();
    setPending(true);

    const updatedListing = deepCopy(listing);
    updatedListing.title = title;

    store.listingStore
      .update(updatedListing)
      .then(() => props.onClose())
      .catch(() => setPending(false));
  };

  return useObserver(() => (
    <Dialog open={props.show} maxWidth={"sm"} fullWidth={true}>
      <form onSubmit={onSubmit} autoComplete={"off"}>
        <DialogTitle>Title</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Quick and catchy title for your home. This will be shown in the
            search results and at the top of the listing preview.
          </DialogContentText>

          <div style={{ height: "2em" }} />

          <TextField
            label={"Title"}
            fullWidth
            defaultValue={title}
            onChange={onChange}
          />
        </DialogContent>

        <DialogActions style={{ marginTop: "1em" }}>
          <Button onClick={props.onClose} disabled={pending}>
            Cancel
          </Button>
          <Button
            type={"submit"}
            variant={"contained"}
            color={"primary"}
            disabled={pending}
          >
            Submit
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  ));
}
